/**
 * ValeoHubilBridge.tsx
 * Placé dans src/components/Item/
 *
 * RÔLE : écoute le CustomEvent 'valeo:openHubil' et ouvre HUBIL via
 * addIframeSlide + makeHubidlpURL — le mécanisme natif NodeAuto.
 *
 * ⚠️  DOIT être rendu à l'intérieur d'un <SlidesProvider> pour que
 *     useAddItemSlide() fonctionne. Voir placement dans CaiaApp.tsx.
 *
 * Retourne null — aucun rendu visuel.
 */

import { useEffect } from 'react';

import { useAuth } from '@/context/AuthContext';
import { makeHubidlpURL } from '@/utils/utils';
import { VALEO_HUBIL_EVENT } from '@/utils/useValeoProxyListener';

import { useAddItemSlide } from './ItemSlides';

export const ValeoHubilBridge = (): null => {
    const { userInfo } = useAuth();
    const { addIframeSlide } = useAddItemSlide();

    useEffect(() => {
        const handler = (e: Event) => {
            const ref = (e as CustomEvent<{ ref: string }>).detail?.ref;

            if (!ref) {
                console.warn('[ValeoHubilBridge] event sans ref');
                return;
            }
            if (!userInfo?.userId) {
                console.warn('[ValeoHubilBridge] userId non disponible');
                return;
            }

            const hubUrl = makeHubidlpURL(userInfo.userId, ref);
            console.log(`[ValeoHubilBridge] ouverture HUBIL → ${hubUrl}`);
            addIframeSlide(hubUrl, true);
        };

        window.addEventListener(VALEO_HUBIL_EVENT, handler);
        return () => window.removeEventListener(VALEO_HUBIL_EVENT, handler);
    }, [userInfo, addIframeSlide]);

    return null;
};
